import { IconButton } from '@csp/csp-web-ui';
import { FC } from 'react';
import { BackButtonProps } from '../model/BackButtonProps';
import { StaticContentService } from '../../../common/service/StaticContentService';

export const HeaderNavBackButton: FC<BackButtonProps> = ({ onBackButtonClick }) => {
  const { icon } = StaticContentService.getPublicBlock('webHcpUserInterfaceCommon', 'accessibility');

  return (
    <IconButton
      aria-label={icon.navBack.accessibilityLabel}
      iconProps={{ name: 'backRound', size: 'large', color: 'black' }}
      onClick={onBackButtonClick}
    />
  );
};
